<!--
/**
* @name: YUploadFile.vue
* @description: 上传文件
* @author: 于海威
* @create: 2020/08/04 09:11:54
* @update: 2020/08/04 09:11:54
*/
-->

<template>
  <div :class="css.inline_block">
    <template v-if="fileType == 'image'">
      <div :class="css.img_upload"
        @click="onSel">
        <k-icon name="icon-icon-tianjiatupian"
          size="40"></k-icon>
      </div>
    </template>
    <template v-else>
      <template v-if="$slots.default">
        <label :class="css.upload_file_label"
          @click="onSel">
          <slot /></label>
      </template>
      <template v-else>
        <a href="javascript:void(0);"><label :class="css.upload_file_label"
            :for="inputName">{{title}}</label></a>
      </template>
    </template>
    <input type="file"
      :class="css.upload_file"
      :id="inputName"
      @change="onUploadFile"
      :multiple="multiple"
      :accept="acceptType" />
  </div>
</template>

<script>
import fetch from '@/assets/modules/fetch';
import { getFileExtension } from '@/assets/modules/uploadFile';

export default {
  props: {
    title: {
      type: String,
      default: '点击上传文件'
    },
    uploadUrl: String,
    acceptType: {
      type: String,
      default: ''
    },
    fileType: String,
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  data() {
    return {
      inputName: `input${Math.random().toString(36).slice(2)}`
    };
  },
  methods: {
    onSel() {
      this.$el.querySelector(`#${this.inputName}`).click();
    },
    onUploadFile(e) {
      const files = e.target.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        if (this.acceptType.toLowerCase().indexOf(getFileExtension(files[i].name).toLowerCase()) < 0) {
          const fileName = files[i].name;
          this.$el.querySelector(`#${this.inputName}`).value = '';
          return this.$root.tip(`${fileName}文件格式不正确`);
        } else {
          formData.append('file', files[i], files[i].name);
        }
      }
      fetch({
        api: this.uploadUrl,
        para: formData,
        type: 'formdata'
      }).then(res => {
        this.$el.querySelector(`#${this.inputName}`).value = '';
        // console.log(res);
        this.$emit('uploaded', res);
      }).catch(() => {
        this.$el.querySelector(`#${this.inputName}`).value = '';
      });
    }
  },
  created() {
    if (this.fileType == 'image') {
      if (!this.acceptType) {
        this.acceptType = '.png,.jpg,.jpeg,.gif';
      }
    }
  }
};
</script>

<style lang="postcss" module="css">
.img_upload {
  width: 120px;
  height: 120px;
  border: solid 1px var(--color-border);
  border-radius: 4px;
  background: var(--color-bg);
  color: #c8c8c8;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  float: left;
}
.inline_block {
  display: inline-block;
}
.upload_file {
  width: 0;
  height: 0;
  visibility: hidden;
  opacity: 0;
}
.upload_file_label {
  cursor: pointer;
  display: inline-block;
  z-index: 1;
  position: relative;
}
</style>
